import scrolling from './scrolling';

/* eslint-disable no-param-reassign */
const onScrollPara = function onScrollParallax(cache, sT) {
  const {
    el,
    height,
    top,
  } = cache;

  /* eslint-disable no-param-reassign */
  cache.rate = cache.rate
    || parseInt(el.getAttribute('data-rate') || 100, 10);
  /* eslint-enable no-param-reassign */
  const tY = (sT + scrolling.getWindowHeight() * 0.5
    - (top + height * 0.5)) * (1 - cache.rate * 0.01);

  const transform = `translate3d(0, ${tY}px, 0)`;

  el.children[0].style.transform = transform;
  el.children[0].style['-webkit-transform'] = transform;
};

scrolling.addCallback('para', onScrollPara);

/* eslint-enable no-param-reassign */
export default {};
